import { render, staticRenderFns } from "./EditableRatioCell.vue?vue&type=template&id=72c6eb56&scoped=true&"
import script from "./EditableRatioCell.vue?vue&type=script&lang=js&"
export * from "./EditableRatioCell.vue?vue&type=script&lang=js&"
import style0 from "./EditableRatioCell.vue?vue&type=style&index=0&id=72c6eb56&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c6eb56",
  null
  
)

export default component.exports